// extracted by mini-css-extract-plugin
export default {"icon":"voucher-form-rules_icon__3D8fi","title":"voucher-form-rules_title__n0-h4","subtext":"voucher-form-rules_subtext__frqh6","divider":"voucher-form-rules_divider__xjR4u"};